module.exports = __webpack_public_path__ + "static/media/ro.2d32a154.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ro.svg
// module id = 2197
// module chunks = 0